import { parseAsJson } from '@repo/sdk/qs/parsers'
import type { FilterModel, FiltersState } from '@repo/table/filters'
import { filtersSchema } from '@repo/table/query-parsers'

import { migrateOverdueFilters } from './legacy-overdue-filters'

// Money totals that were GBP number filters before they offered a currency (CK-2955).
const MONEY_TOTAL_FILTER_IDS = new Set([
  'bills_amount_due',
  'bills_vat',
  'invoices_amount_due',
  'invoices_total',
  'invoices_total_excl_vat',
  'invoices_vat',
])

const isLegacyMoneyTotalFilter = (filter: FilterModel): filter is FilterModel<'number'> =>
  filter.type === 'number' && MONEY_TOTAL_FILTER_IDS.has(filter.columnId)

/**
 * Shared links and saved views from before CK-2955 hold these totals as number filters typed in
 * GBP. They become amount filters in any currency, which compare the same base-currency total.
 */
const upgradeMoneyTotalFilters = (filters: FiltersState): FiltersState =>
  filters.map(filter =>
    isLegacyMoneyTotalFilter(filter)
      ? {
          columnId: filter.columnId,
          operator: filter.operator,
          type: 'amount',
          values: filter.values.map(amount => ({ amount, currencies: [] })),
        }
      : filter,
  )

/* Loads filters as stored in the URL and in saved views, with older money totals and overdue filters upgraded. */
export const loadsFiltersSchema = filtersSchema.transform(filters =>
  migrateOverdueFilters(upgradeMoneyTotalFilters(filters)),
)

export const loadsFiltersParser = parseAsJson(loadsFiltersSchema.parse).withDefault([])
